import React from 'react';

const Settings2 = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18.887 2.3335H9.11036C4.8637 2.3335 2.33203 4.86516 2.33203 9.11183V18.8768C2.33203 23.1352 4.8637 25.6668 9.11036 25.6668H18.8754C23.122 25.6668 25.6537 23.1352 25.6537 18.8885V9.11183C25.6654 4.86516 23.1337 2.3335 18.887 2.3335ZM8.94703 6.41683C8.94703 5.9385 9.3437 5.54183 9.82203 5.54183C10.3004 5.54183 10.697 5.9385 10.697 6.41683V10.9668C10.697 11.4452 10.3004 11.8418 9.82203 11.8418C9.3437 11.8418 8.94703 11.4452 8.94703 10.9668V6.41683ZM11.0511 19.1949C10.846 19.2812 10.697 19.4734 10.697 19.696V21.5835C10.697 22.0618 10.3004 22.4585 9.82203 22.4585C9.3437 22.4585 8.94703 22.0618 8.94703 21.5835V19.696C8.94703 19.4734 8.79807 19.2813 8.59297 19.1948C7.44862 18.7121 6.6487 17.59 6.6487 16.2752C6.6487 14.5252 8.07203 13.0902 9.82203 13.0902C11.572 13.0902 13.007 14.5135 13.007 16.2752C13.007 17.5901 12.1974 18.7123 11.0511 19.1949ZM19.0504 21.5835C19.0504 22.0618 18.6537 22.4585 18.1754 22.4585C17.697 22.4585 17.3004 22.0618 17.3004 21.5835V17.0335C17.3004 16.5552 17.697 16.1585 18.1754 16.1585C18.6537 16.1585 19.0504 16.5552 19.0504 17.0335V21.5835ZM18.1754 14.8985C16.4254 14.8985 14.9904 13.4752 14.9904 11.7135C14.9904 10.3985 15.8 9.27637 16.9463 8.79381C17.1514 8.70744 17.3004 8.5153 17.3004 8.29271V6.41683C17.3004 5.9385 17.697 5.54183 18.1754 5.54183C18.6537 5.54183 19.0504 5.9385 19.0504 6.41683V8.30437C19.0504 8.52697 19.1993 8.71907 19.4044 8.80557C20.5488 9.28819 21.3487 10.4103 21.3487 11.7252C21.3487 13.4752 19.9254 14.8985 18.1754 14.8985Z",
      fill: "#0072B1"
    }
  )
);
Settings2.displayName = "Icons.Settings2";

export { Settings2 };
//# sourceMappingURL=Settings2.js.map
